import Users from '../../services/Users';
import { Status, createRestSlices, applyReducers, Callback } from './rest';
import { ActionPayload } from '..';
import { Dispatch } from 'redux';
import { User } from '../../models';
import { upsertList } from './remoteUpdate';

const UPDATING_FAVORITES           = 'yoda/users/UPDATING_FAVORITES';
const UPDATING_FAVORITES_SUCCESS   = 'yoda/users/UPDATING_FAVORITES_SUCCESS';
const UPDATING_FAVORITES_FAILURE   = 'yoda/users/UPDATING_FAVORITES_FAILURE';
const UPDATING_FAVORITES_RESET     = 'yoda/users/UPDATING_FAVORITES_RESET';

const SET_AVATAR           = 'yoda/users/SET_AVATAR';
const SET_AVATAR_SUCCESS   = 'yoda/users/SET_AVATAR_SUCCESS';
const SET_AVATAR_FAILURE   = 'yoda/users/SET_AVATAR_FAILURE';

const DISABLING           = 'yoda/users/DISABLING';
const DISABLING_SUCCESS   = 'yoda/users/DISABLING_SUCCESS';
const DISABLING_FAILURE   = 'yoda/users/DISABLING_FAILURE';
const DISABLING_RESET     = 'yoda/users/DISABLING_RESET';

const {
    initialState,
    createReducer, startCreateReducer,
    cancelCreateReducer,
    getReducer, listReducer,
    updateReducer, deleteReducer,
    createAction, startCreateAction,
    cancelCreateAction,
    getAction, listAction,
    updateAction, deleteAction,
} = createRestSlices(Users);

initialState.usersUpdate      = 'idle' as Status;
initialState.usersUpdateError = null;
initialState.disabling        = 'idle' as Status;
initialState.disablingError   = null;

const usersUpdateReducer = (state = initialState, action: ActionPayload) => {
    switch (action.type) {
        case UPDATING_FAVORITES:
            return {
                ...state,
                usersUpdate: 'pending',
                usersUpdateError: null
            };
        case UPDATING_FAVORITES_SUCCESS:
            return {
                ...state,
                usersUpdate: 'succeeded',
                usersUpdateError: null,
                user: action.user,
                users: (state.users || []).map((u: User) => {
                    if (u._id === action.user?._id)
                        return action.user;
                    return u;
                })
            };
        case UPDATING_FAVORITES_FAILURE:
            return {
                ...state,
                usersUpdate: 'failed',
                usersUpdateError: action.error
            };
        case UPDATING_FAVORITES_RESET:
            return {
                ...state,
                usersUpdate: 'idle',
                syncuserId: null,
                usersUpdateError: null
            };
        default:
            return state;
    }
};

const UPDATE = 'yoda/mercure/REMOTE_UPDATE';
const onRemoteUpdateReducer = (state = initialState, action: ActionPayload) => {
    if (action.type !== UPDATE)
        return state;

    const { update: { data, type }} = action;
    if (type !== 'user.updated')
        return state;

    return {
        ...state,
        users: upsertList(state.users, data, (payload) => new User(payload)),
        user: state.user?._id === data._id ? new User({ ...state.user, ...data }) : state.user
    };
};

const avatarReducer = (state = initialState, action: ActionPayload) => {
    switch (action.type) {
        case SET_AVATAR:
            return {
                ...state,
                usersUpdate: 'pending',
                usersUpdateError: null
            };
        case SET_AVATAR_SUCCESS:
            return {
                ...state,
                usersUpdate: 'succeeded',
                usersUpdateError: null,
                user: action.user,
                users: (state.users || []).map((u: User) => {
                    if (u._id === action.user?._id)
                        return action.user;
                    return u;
                })
            };
        case SET_AVATAR_FAILURE:
            return {
                ...state,
                usersUpdate: 'failed',
                usersUpdateError: action.error
            };
        default:
            return state;
    }
};

const disablingReducer = (state = initialState, action: ActionPayload) => {
    switch (action.type) {
        case DISABLING:
            return {
                ...state,
                disabling: 'pending',
                disablingError: null
            };
        case DISABLING_SUCCESS:
            return {
                ...state,
                disabling: 'succeeded',
                disablingError: null,
                user: (state.user?._id === action.user._id) ? action.user : state.user,
                users: (state.users || []).map((u: User) => (
                    u._id === action.user?._id ? action.user : u
                ))
            };
        case DISABLING_FAILURE:
            return {
                ...state,
                disabling: 'failed',
                disablingError: action.error
            };
        case DISABLING_RESET:
            return {
                ...state,
                disabling: 'idle',
                disablingError: null
            };
        default:
            return state;
    }
};
/* Export reducer */
/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default (state = initialState, action: ActionPayload) => {
    return applyReducers(state, action, [
        createReducer, startCreateReducer,
        cancelCreateReducer,
        getReducer, listReducer,
        updateReducer, deleteReducer, usersUpdateReducer,
        avatarReducer, disablingReducer, onRemoteUpdateReducer
    ]);
}

const addFavoriteProjectAction = (projects: string[], callback?: Callback) => {

    return (dispatch: Dispatch) => {
        dispatch({type: UPDATING_FAVORITES});
        return Users.addFavoriteProjects(projects).then((data: Response) => {
            const user = data;
            dispatch({type: UPDATING_FAVORITES_SUCCESS, user});
            setTimeout(() => {
                dispatch({type:UPDATING_FAVORITES_RESET});
            }, 100);
            callback && callback(/*err*/null);
        })
        .catch((error: Error) => {
            dispatch({type: UPDATING_FAVORITES_FAILURE, error: error.message});
            setTimeout(() => {
                dispatch({type: UPDATING_FAVORITES_RESET});
            }, 100);
            callback && callback(error);
        });
    }
}

const removeFavoriteProjectsAction = (projects: string[], callback?: Callback) => {

    return (dispatch: Dispatch) => {
        dispatch({type: UPDATING_FAVORITES});
        return Users.removeFavoriteProjects(projects)
            .then((data: Response) => {
                const user = data;
                dispatch({type: UPDATING_FAVORITES_SUCCESS, user});
                setTimeout(() => {
                    dispatch({type: UPDATING_FAVORITES_RESET});
                }, 100);
                callback && callback(/*err*/null);
            })
            .catch((error: Error) => {
                dispatch({type: UPDATING_FAVORITES_FAILURE, error: error.message});
                setTimeout(() => {
                    dispatch({type: UPDATING_FAVORITES_RESET});
                }, 100);
                callback && callback(error);
            });
    }
};

const setAvatarAction = (id: string, file: File, callback?: Callback) => {

    return (dispatch: Dispatch) => {
        dispatch({type: SET_AVATAR});
        return Users.setAvatar(id, file).then((data: AnyObj) => {
            const { user } = data;
            dispatch({type: SET_AVATAR_SUCCESS, user});
            callback && callback(/*err*/null);
        })
        .catch((error: Error) => {
            dispatch({type: SET_AVATAR_FAILURE, error: error.message});
            callback && callback(error);
        });
    }
}

const unsetAvatarAction = (id: string, callback?: Callback) => {

    return (dispatch: Dispatch) => {
        dispatch({type: SET_AVATAR});
        return Users.unsetAvatar(id).then((data: AnyObj) => {
            const { user } = data;
            dispatch({type: SET_AVATAR_SUCCESS, user});
            callback && callback(/*err*/null);
        })
        .catch((error: Error) => {
            dispatch({type: SET_AVATAR_FAILURE, error: error.message});
            callback && callback(error);
        });
    }
}

const deactivateUserAction = (id: string, callback?: Callback) => {
    return (dispatch: Dispatch) => {
        dispatch({type: DISABLING});
        return Users.deactivate(id)
            .then((data: Response) => {
                const { user } = data;
                dispatch({type: DISABLING_SUCCESS, user});
                setTimeout(() => {
                    dispatch({type: DISABLING_RESET});
                }, 100);
                callback && callback(/*err*/null);
            })
            .catch((error: Error) => {
                dispatch({type: DISABLING_FAILURE, error: error.message});
                setTimeout(() => {
                    dispatch({type: DISABLING_RESET});
                }, 100);
                callback && callback(error);
            });
    };
};

const activateUserAction = (id: string, callback?: Callback) => {
    return (dispatch: Dispatch) => {
        dispatch({type: DISABLING});
        return Users.activate(id)
            .then((data: Response) => {
                const { user } = data;
                dispatch({type: DISABLING_SUCCESS, user});
                setTimeout(() => {
                    dispatch({type: DISABLING_RESET});
                }, 100);
                callback && callback(/*err*/null);
            })
            .catch((error: Error) => {
                dispatch({type: DISABLING_FAILURE, error: error.message});
                setTimeout(() => {
                    dispatch({type: DISABLING_RESET});
                }, 100);
                callback && callback(error);
            });
    };
};

/* Export CRUD actions */
export const createUser             = createAction;
export const startCreateUser        = startCreateAction;
export const cancelCreateUser       = cancelCreateAction;
export const loadUser               = getAction;
export const loadUsers              = listAction;
export const updateUser             = updateAction;
export const deleteUser             = deleteAction;
export const addFavoriteProjects    = addFavoriteProjectAction;
export const removeFavoriteProjects = removeFavoriteProjectsAction;
export const setUserAvatar          = setAvatarAction;
export const unsetUserAvatar        = unsetAvatarAction;
export const deactivateUser         = deactivateUserAction;
export const activateUser           = activateUserAction;
